var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('GetFile',{staticClass:"mr-3",on:{"get-file":function($event){return _vm.getPDF('pdf')}}}),_c('v-container',{staticClass:"h-70",attrs:{"fluid":""}},[_c('canvas',{ref:"content",attrs:{"width":"100%","height":"100%"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }